// collapsible.ts
export function initCollapsible(): void {
    const wrappers = document.querySelectorAll<HTMLElement>('.collapsible-wrapper');

    wrappers.forEach(wrapper => {
        const btn = wrapper.querySelector<HTMLButtonElement>('.read-more-btn');
        if (!btn) return;

        if ((btn as any)._collapsibleInitialized) return;
        (btn as any)._collapsibleInitialized = true;

        const labelSpan = btn.querySelector<HTMLSpanElement>('.btn-label');
        if (!labelSpan) return;

        btn.addEventListener('click', () => {
            console.log("click");
            wrapper.classList.toggle('expanded');

            const isExpanded = wrapper.classList.contains('expanded');
            labelSpan.textContent = isExpanded
                ? btn.dataset.expanded ?? 'Read Less'
                : btn.dataset.collapsed ?? 'Read More';
        });
    });
}